import {
  AdminExamCenterLocationList,
  AdminExamLocationSearchFilter,
} from '@exam-center/exam-location-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Flex, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function PermissionRequiredExamLocationManagementLocationsPage() {
  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION.VIEW,
        APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_USAGE.VIEW,
      ]}
      options={{
        operator: 'OR',
      }}
    >
      <ExamLocationManagementLocationsPage />
    </PermissionGuard>
  );
}

function ExamLocationManagementLocationsPage() {
  return (
    <PaperSection title='สถานที่สอบทั้งหมด'>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(4),
          p: theme.spacing(6),
        })}
      >
        <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(4) })}>
          <AdminExamLocationSearchFilter />
          <AdminExamCenterLocationList />
        </Flex>
      </Flex>
    </PaperSection>
  );
}
